<script>
import ListingModel from "@/views/Training/TrainingSession/Components/ListingModel.vue";

export default {
    name: "ColdEvaluations",
    components: {ListingModel}
}
</script>

<template>
    <ListingModel type="COLD"/>
</template>